import { createJSONStorage, persist } from "zustand/middleware";

import { create } from "zustand";

export const invoiceDetailsStore = create(
  persist(
    (set) => ({
      details: {},
      setInvoiceDetails: (info) => set(() => ({ details: info })),
      shouldUseStore: false,
      setshouldUseStore: (x) => set(() => ({ shouldUseStore: x })),
      useTemplateInvoiceProperty: false,
      setuseTemplateInvoiceProperty: (bool) => set(()=>({useTemplateInvoiceProperty: bool}))
    }),
    {
      name: "invoice-details-data",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export function getInvoiceDetails(){
   return invoiceDetailsStore.getState().details;
}
export function setInvoiceDetails(info){
   return invoiceDetailsStore.getState().setInvoiceDetails(info);
}
export function getshouldUseStore() {
  return invoiceDetailsStore.getState().shouldUseStore;
}
export function setshouldUseStore(bool) {
  return invoiceDetailsStore.getState().setshouldUseStore(bool);
}
export function setuseTemplateInvoiceProperty(bool) {
  return invoiceDetailsStore.getState().setuseTemplateInvoiceProperty(bool);
}
